import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet";
import Footer from '../../../Components/Footer/Footer';
import Navigation from '../../../Components/v1/NavBar/Navigaton';
import ListAllServices from '../../../Components/v1/Services/ListAllServices';
import ScheduleMeetBanner from '../../../Components/v1/Home/ScheduleMeetBanner';
import Testimonial from '../../../Components/v1/Home/Testimonial';
import AppDownload from '../../../Components/v1/Home/AppDownload';
import FAQ from '../../../Components/v1/Home/FAQ';
import Newsletter from '../../../Components/v1/Home/Newletter';
import SpecificServicesComponent from '../../../Components/v1/Services/SpecificServicesComponent';
import ServiceRequestModal from '../../../Components/v1/Services/ServiceRequestModal';


export default function SpecificService() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hasClosedOnce, setHasClosedOnce] = useState(false);

  useEffect(() => {
    window.scroll(0, 0);
    const initialTimer = setTimeout(() => {
      setIsModalOpen(true);
    }, 1000);
    return () => clearTimeout(initialTimer);
  }, []);

  const handleModalClose = () => {
    setIsModalOpen(false);
    setHasClosedOnce(true);
    setTimeout(() => {
      setIsModalOpen(true);
    }, 5000);
  };


  return (
    <div className="innerpages-nav">
      <div id="container" >
        <Navigation />
        <SpecificServicesComponent />
        <ScheduleMeetBanner />
        <Testimonial />
        {/* <AppDownload/> */}
        <Newsletter />
        <FAQ />
        <Footer />
      </div>
      {/* <ServiceRequestModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        category={"service"}
        subcategory={""}
        hasClosedOnce={hasClosedOnce}
      /> */}
    </div>
  );
}
